module.exports = "https://static.wanderu.com/ui-react/_next/static/media/thenewyorker.d0937c86.png";